export const ru = {
    'minus-keywords-illegal-minus-keyword-chars':
        'В минус-фразах разрешается использовать только буквы английского, турецкого, казахского, русского, украинского или белорусского алфавита, кавычки, квадратные скобки, знаки «-», «+», «!», пробел. Ошибки во фразах: {minusWords}',
    'minus-keywords-imbalanced-square-brackets':
        'Неправильное использование скобок «[» «]» в минус-фразах: {minusWords}',
    'minus-keywords-invalid-dot':
        'Минус-фразы могут содержать не более двух цифр подряд через точку. Ошибки во фразах: {minusWords}',
    'minus-keywords-invalid-exclamation-mark': 'Неправильное использование знака «!» в минус-фразах: {minusWords}',
    'minus-keywords-invalid-minus-mark':
        'Неправильное использование знака «-» в минус-фразах: {minusWords}. Знак «-» нельзя использовать в начале и в конце слов',
    'minus-keywords-invalid-operators-inside-square-brackets':
        'Внутри скобок [] недопустимы символы +-"", минус-фразы: {minusWords}',
    'minus-keywords-invalid-plus-mark': 'Неправильное использование знака «+» в минус-фразах: {minusWords}',
    'minus-keywords-invalid-word-first-character':
        'Неправильное сочетание специальных символов в минус-фразах: {minusWords}',
    'minus-keywords-max-count-words-in-keyword':
        'Минус-фраза не может состоять более чем из {maxWords} слов: {minusWords}',
    'minus-keywords-max-length':
        'Превышена допустимая длина слова в минус-фразе в {maxLength} символов. Ошибки во фразах: {minusWords}',
    'minus-keywords-max-length-minus-keywords': 'Превышен лимит в {maxLength} символов в минус-фразах на группу',
    'minus-keywords-nested-or-empty-square-brackets':
        'Квадратные скобки «[» «]» не могут быть пустыми и вложенными, минус-фразы: {minusWords}',
    'minus-keywords-null': 'Минус-фразы на группу не могут содержать пустые значения',
    'minus-keywords-separate-dot': 'Минус-фразы не могут содержать отдельно стоящие точки: {minusWords}',
    'minus-keywords-wrong-quote': 'Неправильное использование кавычек в минус-фразах: {minusWords}',
    'minus-phrase-binding-many-phrases-list-error': {
        one: 'Не удалось привязать наборы к выбранной группе',
        some: 'Не удалось привязать наборы к выбранным группам',
        many: 'Не удалось привязать наборы к выбранным группам',
        none: 'Не удалось привязать наборы к выбранным группам'
    },
    'minus-phrase-binding-many-phrases-list-error-many': 'Не удалось привязать наборы к выбранным группам',
    'minus-phrase-binding-many-phrases-list-error-one': 'Не удалось привязать наборы к выбранной группе',
    'minus-phrase-binding-many-phrases-list-success': {
        one: 'Наборы привязаны к выбранной группе',
        some: 'Наборы привязаны к выбранным группам',
        many: 'Наборы привязаны к выбранным группам',
        none: 'Наборы привязаны к выбранным группам'
    },
    'minus-phrase-binding-many-phrases-list-success-many': 'Наборы привязаны к выбранным группам',
    'minus-phrase-binding-many-phrases-list-success-one': 'Наборы привязаны к выбранной группе',
    'minus-phrase-binding-many-phrases-list-warning': {
        one: 'Наборы привязаны к {count} группе из {total}. В остальных не удалось ',
        some: 'Наборы привязаны к {count} группам из {total}. В остальных не удалось ',
        many: 'Наборы привязаны к {count} группам из {total}. В остальных не удалось ',
        none: 'Наборы привязаны к {count} группам из {total}. В остальных не удалось '
    },
    'minus-phrase-binding-one-phrases-list-error': {
        one: 'Не удалось привязать набор к выбранной группе',
        some: 'Не удалось привязать набор к выбранным группам',
        many: 'Не удалось привязать набор к выбранным группам',
        none: 'Не удалось привязать набор к выбранным группам'
    },
    'minus-phrase-binding-one-phrases-list-error-many': 'Не удалось привязать набор к выбранным группам',
    'minus-phrase-binding-one-phrases-list-error-one': 'Не удалось привязать набор к выбранной группе',
    'minus-phrase-binding-one-phrases-list-success': {
        one: 'Набор привязан к выбранной группе',
        some: 'Набор привязан к выбранным группам',
        many: 'Набор привязан к выбранным группам',
        none: 'Набор привязан к выбранным группам'
    },
    'minus-phrase-binding-one-phrases-list-success-many': 'Набор привязан к выбранным группам',
    'minus-phrase-binding-one-phrases-list-success-one': 'Набор привязан к выбранной группе',
    'minus-phrase-binding-one-phrases-list-warning': {
        one: 'Набор привязан к {count} группе из {total}. В остальных не удалось',
        some: 'Набор привязан к {count} группам из {total}. В остальных не удалось',
        many: 'Набор привязан к {count} группам из {total}. В остальных не удалось',
        none: 'Набор привязан к {count} группам из {total}. В остальных не удалось'
    },
    'minus-phrase-unbinding-many-phrases-list-error': {
        one: 'Не удалось отвязать наборы от выбранной группы',
        some: 'Не удалось отвязать наборы от выбранных групп',
        many: 'Не удалось отвязать наборы от выбранных групп',
        none: 'Не удалось отвязать наборы от выбранных групп'
    },
    'minus-phrase-unbinding-many-phrases-list-error-many': 'Не удалось отвязать наборы от выбранных групп',
    'minus-phrase-unbinding-many-phrases-list-error-one': 'Не удалось отвязать наборы от выбранной группы',
    'minus-phrase-unbinding-many-phrases-list-success': {
        one: 'Наборы отвязаны от выбранной группы',
        some: 'Наборы отвязаны от выбранных групп',
        many: 'Наборы отвязаны от выбранных групп',
        none: 'Наборы отвязаны от выбранных групп'
    },
    'minus-phrase-unbinding-many-phrases-list-success-many': 'Наборы отвязаны от выбранных групп',
    'minus-phrase-unbinding-many-phrases-list-success-one': 'Наборы отвязаны от выбранной группы',
    'minus-phrase-unbinding-many-phrases-list-warning': {
        one: 'Наборы отвязаны от {count} группы из {total}. В остальных не удалось ',
        some: 'Наборы отвязаны от {count} групп из {total}. В остальных не удалось ',
        many: 'Наборы отвязаны от {count} групп из {total}. В остальных не удалось ',
        none: 'Наборы отвязаны от {count} групп из {total}. В остальных не удалось '
    },
    'minus-phrase-unbinding-one-phrases-list-error': {
        one: 'Не удалось отвязать набор от выбранной группы',
        some: 'Не удалось отвязать набор от выбранных групп',
        many: 'Не удалось отвязать набор от выбранных групп',
        none: 'Не удалось отвязать набор от выбранных групп'
    },
    'minus-phrase-unbinding-one-phrases-list-error-many': 'Не удалось отвязать набор от выбранных групп',
    'minus-phrase-unbinding-one-phrases-list-error-one': 'Не удалось отвязать набор от выбранной группы',
    'minus-phrase-unbinding-one-phrases-list-success': {
        one: 'Набор отвязан от выбранной группы',
        some: 'Набор отвязан от выбранных групп',
        many: 'Набор отвязан от выбранных групп',
        none: 'Набор отвязан от выбранных групп'
    },
    'minus-phrase-unbinding-one-phrases-list-success-many': 'Набор отвязан от выбранных групп',
    'minus-phrase-unbinding-one-phrases-list-success-one': 'Набор отвязан от выбранной группы',
    'minus-phrase-unbinding-one-phrases-list-warning': {
        one: 'Набор отвязан от {count} группы из {total}. В остальных не удалось ',
        some: 'Набор отвязан от {count} групп из {total}. В остальных не удалось ',
        many: 'Набор отвязан от {count} групп из {total}. В остальных не удалось ',
        none: 'Набор отвязан от {count} групп из {total}. В остальных не удалось '
    }
};
